export enum PreWorkupLabStep {    
    PendingStart = 0,
    JugShipped = 5,
    JugGetOwn = 10,
    PendingLabs = 15,
    LabChoice = 20,
    PhlebotPending = 100,
    PhlebotReadyForBatch = 105,
    PhlebotPendingScrip = 110,
    PhlebotScripUploaded = 115,
    PhlebotPendingWithScrip = 118,
    PhlebotScripDownloaded = 120,
    QuestReadyForBatch = 200,
    QuestPendingScrip = 205,
    QuestScripUploaded = 210,
    QuestScripDownloaded = 215,
    QuestMissingLabs = 299,
    Complete = 500,
    DirectToCenter = 501,
    PhlebotComplete = 502,
    QuestComplete = 503,
    Incomplete = 1000,
    IncompleteJug = 1001,
    IncompleteLabs = 1002,
    IncompleteQuest = 1003,
    IncompletePhlebot = 1004
}